import { withStyles } from '@material-ui/core/styles';
import Login from './Login';

const styles = () => ({
  formContainer: {
    height: 'auto',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
});

export default withStyles(styles)(Login);
